module App.Interfaces {
    export interface IRole {
        id: number;
        name: string;
        rights: string[];
        isSystemRole: boolean;
    }
}

